import loadingTextBundle from '../i18n_js/loadingTextBundle';
import { loadLocalizers } from './I18nLoader';
export const embeddedBundle = loadLocalizers(loadingTextBundle, navigator.languages);
//# sourceMappingURL=embeddedI18N.js.map